import React from "react";
import PropTypes from "prop-types";
import ErrorImage from "../assets/error/error-occurred.svg";
import Ellipse1 from "../assets/error/Ellipse 24.svg";
import Ellipse2 from "../assets/error/Ellipse 22.svg";
import Ellipse3 from "../assets/error/Ellipse 21.svg";
import Ellipse4 from "../assets/error/Ellipse 23.svg";

const ErrorPage = ({
  errorMessage = "An error occurred",
  buttonText = "Go Back to Homepage",
  onButtonClick,
  showIcon = true,
}) => {
  return (
    <div className="h-screen w-full bg-[#D8DEEF] font-alexandria flex items-center justify-center p-4">
            <img
        src={Ellipse1}
        alt="Ellipse 1"
        className="absolute bottom-0 left-0 w-[200px] sm:w-[250px] md:w-[380px] z-10"
      />
      <img
        src={Ellipse4}
        alt="Ellipse 4"
        className="absolute bottom-0 left-0 w-[150px] sm:w-[200px] md:w-[400px] z-10 opacity-[60%]"
      />
      <img
        src={Ellipse2}
        alt="Ellipse 2"
        className="absolute bottom-0 left-0 w-[150px] sm:w-[200px] md:w-[250px] z-10"
      />
      <img
        src={Ellipse3}
        alt="Ellipse 2"
        className="absolute  bottom-0 left-0 w-[150px] sm:w-[200px] md:w-[250px] opacity-[60%] z-10"
      />
      <div className="bg-white rounded-[20px]  border border-[#E5E5E5] w-[950px] h-auto md:h-[670px] flex flex-col md:flex-row items-start justify-start p-10 sm:p-16 lg:px-[125px] md:py-[140px] relative z-10">
        <div className="text-left space-y-[40px]  md:space-y-[70px]">
          <p className="text-left max-w-[233px] leading-[100%] font-medium text-transparent bg-clip-text bg-gradient-to-b from-[#4772F1] to-[#873FE2] text-[50px] font-alexandria">
            {errorMessage}
          </p>
          <p className="my-[70px] text-[16px] lg:text-[20px] text-[#4772F1] max-w-[385px]  md:max-w-[330px] lg:max-w-[385px]">
            Something went wrong. Please refresh the page or contact support.
          </p>
          {/* {onButtonClick && (*/}
          <div className="flex flex-row-reverse gap-2 sm:gap-4">
            <button
              type="button"
              // onClick={onButtonClick}
              onClick={() => (window.location.href = "/")}
              className="h-[48px] sm:h-[55px] text-[12px] text-center  px-2 sm:px-6 py-2 sm:text-[16px] md:text-[16px] lg:text-[18px] text-[#FFFFFF] w-full md:w-[268px] bg-[#4772F1] border-[2px] border-[#4772F1] hover:bg-[#3a2ecc] font-semibold rounded-[8px] transition-colors duration-300"
            >
              {buttonText}
            </button>
            {/*)}*/}
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="h-[48px] sm:h-[55px]  px-6 py-2  text-[12px] sm:text-[16px] md:text-[16px] lg:text-[18px] text-[#93ABF3] bg-white border-[2px] border-[#93ABF3]  font-semibold rounded-[8px] hover:text-[#5f78c4] hover:border-[#5f78c4] transition-colors duration-300"
            >
              Retry
            </button>{" "}
          </div>{" "}
        </div>

        {showIcon && (
          <img
            src={ErrorImage}
            alt="Error illustration"
            className="w-full sm:w-[302px] sm:h-[302px] lg:w-[333px] lg:h-[334.25px] mt-10 md:mt-0"
          />
        )}
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  errorMessage: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  showIcon: PropTypes.bool,
};

export default ErrorPage;
